

















































import { Component, Prop, Vue } from 'vue-property-decorator';
import Croppa from 'vue-croppa';
import VerticalSeparator from './VerticalSeparator.vue';
import ImagePositionHandler from '../ImagePositionHandler';
import ImageAlignmentToolbar from './ImageAlignmentToolbar.vue';
import { ImageAlignment, ImageSize } from './constants';
import { TEN, TWO } from '../../../constants';

@Component({
  components: { ImageAlignmentToolbar, VerticalSeparator }
})
export default class ImageControlsToolbar extends Vue {
  @Prop() croppa!: typeof Croppa.component;

  @Prop() imageSize!: ImageSize;

  @Prop() canvasScale!: number;

  @Prop() toolBarToTheRight!: boolean;

  @Prop() defaultScale!: number;

  @Prop() showLargeSizeControl!: boolean;

  @Prop() showMediumSizeControl!: boolean;

  @Prop({ default: true }) withResizeOption!: boolean;

  imageAlignment = ImageAlignment;

  imagePositionHandler!: ImagePositionHandler;

  showAlignmentToolbar = false;

  showResizeToolbar = false;

  scaleSlider = {
    value: 0,
    min: 0,
    max: 0
  };

  created() {
    this.init();
  }

  init() {
    setTimeout(() => {
      if (!this.croppa.$on) {
        this.init();
        return;
      }
      this.initPositionHandler();
      this.initSlider();
      this.croppa.$on('zoom', this.setSliderValue);
    }, TEN);
    this.setFocusToCropper();
  }

  setFocusToCropper() {
    this.$nextTick(() => {
      const cropper = document.getElementById('decrease-croppa-button');
      if (cropper) {
        cropper.focus();
      }
    });
  }

  setSliderValue() {
    const { scale } = this.croppa.getMetadata();
    this.scaleSlider.value = scale.toFixed(TWO);
  }

  initPositionHandler() {
    this.imagePositionHandler = new ImagePositionHandler(this.croppa);
  }

  updateAlignment(data: ImageAlignment) {
    switch (data) {
      case ImageAlignment.left:
        return this.imagePositionHandler.toLeft();
      case ImageAlignment.right:
        return this.imagePositionHandler.toRight();
      case ImageAlignment.bottom:
        return this.imagePositionHandler.toBottom();
      case ImageAlignment.top:
        return this.imagePositionHandler.toTop();
      case ImageAlignment.center:
        return this.imagePositionHandler.toCenter();
      default:
        return this.imagePositionHandler.toCenter();
    }
  }

  updateSize(data: ImageSize) {
    this.$emit('resize-toolbar:choose', data);
  }

  initSlider() {
    setTimeout(() => {
      if (this.croppa.scaleRatio === null) {
        return this.initSlider();
      }

      this.scaleSlider.value = this.croppa.scaleRatio;
      this.scaleSlider.min = (this.defaultScale ? this.defaultScale * this.canvasScale : this.croppa.scaleRatio) / TEN;
      this.scaleSlider.max = (this.defaultScale ? this.defaultScale * this.canvasScale : this.croppa.scaleRatio) * TEN;
      return null;
    }, TEN);
  }

  cropImage() {
    this.$emit('crop-image');
  }

  onSliderChange(evt: InputEvent) {
    const increment = (evt.target as HTMLInputElement).value;
    this.croppa.scaleRatio = +increment;
    this.$emit('zoom-image');
  }
}
